import { Language } from '~/shared/constants/langConstants'
import { ScreenName } from '~/shared/services/eventLogger'
import { IAppState } from '~/shared/store/types'
import { TAnswers } from '~/shared/types/commonTypes'
import { FirebaseConfig, IAppConfig } from '~/shared/types/configTypes'
import { IStep, IVariant } from '~/shared/types/variantTypes'

export const selectIsFetching = (state: IAppState): boolean =>
  state.common.isFetching
export const selectActionList = (state: IAppState): string[] =>
  state.common.actionList
export const selectError = (state: IAppState): any => state.common.error
export const selectCohortID = (state: IAppState): string =>
  state.common.currentVariant?.cohort || ''
export const selectParentCohortID = (state: IAppState): string =>
  state.common.currentVariant?.parentCohort || ''
export const selectCurrentVariantSteps = (state: IAppState): IStep[] =>
  state.common.currentVariant?.steps || []
export const selectFacebookPixelIds = (state: IAppState) =>
  state.common.currentVariant?.facebookPixelIds || []
export const selectApplovinPixelId = (state: IAppState) =>
  state.common.currentVariant?.applovinPixelId || ''
export const selectTiktokPixelId = (state: IAppState): string =>
  state.common.currentVariant?.tiktokPixelId || ''
export const selectCurrentVariant = (state: IAppState): IVariant | null =>
  state.common.currentVariant || null
export const selectConfig = (state: IAppState): IAppConfig | null =>
  state.common.appConfig
export const selectAmplitudeApiKey = (state: IAppState): string =>
  state.common.appConfig?.amplitudeApiKey || ''
export const selectGiaApiKeys = (
  state: IAppState,
): Record<string, string> | null => state.common.appConfig?.giaApiKeys || null
export const selectGoogleTagManagerId = (state: IAppState): string =>
  state.common.currentVariant?.googleTagManagerId || ''
export const selectAnswers = (state: IAppState): Partial<TAnswers> | null =>
  state.common.answers
export const selectLanguage = (state: IAppState): Language =>
  state.common.language
export const selectScreenName = (state: IAppState): ScreenName =>
  state.common.screenName
export const selectHasUpsellOffer = (state: IAppState): boolean =>
  state.common.currentVariant?.hasUpsellOffer || false
export const selectHasCancelOffer = (state: IAppState) =>
  state.common.currentVariant?.hasCancelOffer || false
export const selectGrowthBookExperiments = (
  state: IAppState,
): Record<string, Record<string, string>> | null =>
  state.common.currentVariant?.growthBookExperiments || null
export const selectDynamicDiscount = (state: IAppState) =>
  state.common.dynamicDiscount || null
export const selectIsInContextEnabled = (state: IAppState): boolean =>
  state.common.isInContextEnabled
export const selectFirebaseConfig = (state: IAppState): FirebaseConfig | null =>
  state.common.appConfig?.firebaseConfig ?? null
export const selectOnboardingProgressbarBreakpoints = (state: IAppState) =>
  state.common.currentVariant?.onboardingProgressBreakpoints || {}
